import { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { Spinner } from '@factorialco/f0-react/dist/experimental'
import { UpsellLandingPagesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { LandingPageBlocks } from 'modules/discover/components/LandingPageBlocks'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { getDatoLocale } from 'modules/onboarding/lib/datoLocale'
import { SelfUpsellProvider } from 'modules/upsell/store/SelfUpsellProvider'

const LandingPage = () => {
  const {
    access: { locale },
  } = useCurrentSession()
  const { search } = useLocation()

  const datoLocale = getDatoLocale(locale)
  const { id } = useParams()
  const preview = new URLSearchParams(search).get('preview') === 'true'

  const { data: landingPageData, loading } = useQuery(UpsellLandingPagesDocument, {
    variables: { locale: datoLocale, slug: id || '', preview },
  })

  const landingPage = landingPageData?.upsell.landingPagesConnection.edges[0]?.node

  useEffect(() => {
    if (landingPage) {
      track(trackingEvents.discover.seeLandingPage, {
        slug: landingPage.slug,
      })
    }
  }, [landingPage])

  if (loading) {
    return <Spinner />
  }

  return (
    <SelfUpsellProvider
      availableAddons={landingPage?.moduleRelated?.billingAddonReference || []}
      availableCrossSellingAddons={landingPage?.moduleRelated?.billingAddonReference || []}
      moduleName={landingPage?.moduleRelated?.chargebeeModuleName || ''}
    >
      <ResponsivePage.Body variant="fullscreen" authorized={!!landingPage}>
        <Box
          gap="s80"
          style={{ maxWidth: '1200px', width: '100%', margin: '0 auto' }}
          padding="s32"
        >
          {landingPage?.slug && (
            <LandingPageBlocks
              blocks={landingPage?.blocks}
              slug={landingPage.slug}
              landingPage={landingPage}
            />
          )}
        </Box>
      </ResponsivePage.Body>
    </SelfUpsellProvider>
  )
}

export default LandingPage
